export const petFormToModel = pet => ({
  name: pet.name,
  weight: pet.weight,
  is_neutered: pet.spayedStatus,
  activity_level: pet.activity,
  birth_date: `${pet.year}-${pet.month}-01`,
});
